import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { useContext, useState } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import destination_configuration_form_props from '../Forms/destination_configuration';
import RadioCardsInput from '../../../../common/Form/Fields/RadioCardsInput';
import SelectInput from '../../../../common/Form/Fields/SelectInput';
import { DashboardContext } from '../../DashboardContext';
import { IconName } from '../../../../common/base/Icon';
const DestinationSection = () => {
  const $ = _c(23);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    destination_types
  } = useContext(DashboardContext);
  const [t0] = useField("destination_use");
  const {
    value: use
  } = t0;
  const [search_term, setSearchTerm] = useState("");
  let filters;
  let t1;
  let t2;
  if ($[0] !== search_term) {
    filters = {
      limit: 100,
      name: search_term ? {
        contains: search_term
      } : undefined
    };
    t1 = useSWR;
    t2 = APIMethodKeys.destinations.list(filters);
    $[0] = search_term;
    $[1] = filters;
    $[2] = t1;
    $[3] = t2;
  } else {
    filters = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.destinations || $[5] !== filters) {
    t3 = () => HookdeckAPI.destinations.list(filters);
    $[4] = HookdeckAPI.destinations;
    $[5] = filters;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: destinations,
    isValidating
  } = t1(t2, t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      b: 6
    };
    t5 = {
      value: "new",
      label: "Create new destination"
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const t6 = !destinations?.models.length;
  let t7;
  if ($[9] !== t6) {
    t7 = <RadioCardsInput name="destination_use" m={t4} options={[t5, {
      value: "select",
      label: "Re-use existing destination",
      disabled: t6
    }]} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== destination_types || $[12] !== destinations?.models || $[13] !== isValidating || $[14] !== search_term || $[15] !== use) {
    t8 = use === "select" && <SelectInput name="destination_id" label="Destination" required={true} search={true} placeholder="Select..." search_placeholder="Find a destination..." separator={false} sublte_error={true} options={destinations?.models.map(destination => ({
      value: destination.id,
      label: destination.name,
      icon: destination_types[destination.type].icon as IconName
    })) || []} width={100} block={true} search_term={search_term} setSearchTerm={setSearchTerm} search_is_loading={isValidating} />;
    $[11] = destination_types;
    $[12] = destinations?.models;
    $[13] = isValidating;
    $[14] = search_term;
    $[15] = use;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== use) {
    t9 = use === "new" && <Div m={{
      t: 6
    }}><destination_configuration_form_props.Fields prefix="destination" /></Div>;
    $[17] = use;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <>{t7}{t8}{t9}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default DestinationSection;